import $ from 'jquery';

$(function() {
  var cwEnquiryformclass = $('.cw-new-theme .fa-enquiry-form').length;
  if(cwEnquiryformclass > 0){
    $.fn.isOnScreen = function () {
      var win = $(window);
      var viewport = {
          top: win.scrollTop(),
          left: win.scrollLeft()
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      var bounds = this.offset();
      bounds.right = bounds.left + this.outerWidth();
      bounds.bottom = bounds.top + this.outerHeight();
      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };
    $(window).scroll(function () {
      if ($('.cw-new-theme .fa-enquiry-form').isOnScreen() == true) {
        $(".enquiry-ribbon").hide();
          $('.cw-default-nav').addClass('cw-margin0');
         
      }
      else{
        $('.enquiry-ribbon').show();
        $('.cw-default-nav').removeClass('cw-margin0');
    }
    });
  }
});


// Hamburger toggle
$('.cw-default-nav #cw-navbar-toggle').on('click', function() {
    this.classList.toggle('active');
    $('.cw-default-nav .cw-nav').slideToggle();
  });
  

if($(window).width() < 1025) {
    $('.cw-default-nav ul.cw-nav li.cw-dropdown button.cw-icon-right-ar:not(:only-child)').click(function(e) {
        $(this).siblings('.cw-default-nav .cw-nav .cw-dropdown-content').slideToggle("slow");
        $(this).siblings('.cw-default-nav .cw-nav .cw-dropdown-content').parent('.cw-dropdown').toggleClass('active');
        // Close dropdown when select another dropdown
        $('.cw-default-nav .cw-nav .cw-dropdown-content').not($(this).siblings()).hide("slow");
        $('.cw-default-nav .cw-nav .cw-dropdown-content').not($(this).siblings()).parent('.cw-dropdown').removeClass("active");
        e.stopPropagation();
      });
   
}
if($(window).width() > 1024) {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 40) {
        $('.cw-default-nav').addClass('cw-default-nav-sticky'); 
        $('.cw-top-bar').hide();
      }
      else{
        $('.cw-default-nav').removeClass('cw-default-nav-sticky'); 
        $('.cw-top-bar').show();
      }
    });

  
}






// WEBPACK FOOTER //
// ./components/cw-header/scripts/_cw-header.js